import React , {useEffect, useState  }   from 'react';
import { useSelector , useDispatch} from 'react-redux';
import { useCallback } from 'react';
import { useNavigate  } from "react-router-dom";
import axios from 'axios';
//import Gleap from 'gleap';

import { axios_memory_memoclick } from '../axios/axios_memory';


// import { modifyEcran ,defineGleap } from '../state/redux';
import { modifyEcran  } from '../state/redux';
import { useUser } from '../state/reactquery';


import { initialiseSocket } from '../utils/socket';
import { initialisetwilio }  from '../utils/twilio';
import { formatdatenotif } from '../utils/utils_dates';
import { verifieversion } from '../utils/verifversion';
import { findCourtierCompagniesDatas } from '../utils/compagnies';
import { initialiseringover } from '../utils/ringover';
import { initialiseaircall } from '../utils/aircall';
import {handle_incoming_call,handle_call_end_ringtone,handle_call_ended,handle_comment_saved,
         handle_outgoing_call, handle_outgoing_answered}from '../utils/utils_phone';

import EcranParametres from '../Ecrans/EcranParametres/EcranParametres';

import EcranFicheClient  from "../Ecrans/EcranFicheClient/EcranFicheClient";
import EcranDev from "../Ecrans/EcranDev/EcranDev";
import EcranDev2 from "../Ecrans/EcranDev2/EcranDev2";
import EcranGestion from "../Ecrans/EcranGestion/EcranGestion";
import EcranGestionOneClient from '../Ecrans/EcranGestionOneClient/EcranGestionOneClient';
import GestionRecherche    from '../Components/Gestion/GestionRecherche';
// import EcranTickets from "../Ecrans/EcranTickets/EcranTickets";
import EcranDashboard from '../Ecrans/EcranDashboard/EcranDashboard';
import EcranFormulaire from '../Components/Formulaire/EcranFormulaire';
import EcranEmailsGestion from '../Ecrans/EcranEmails/EcranEmailsGestion';
import EcranEmailsClients from "../Ecrans/EcranEmails/EcranEmailsClients";
import EcranSuperAdmin from "../Ecrans/EcranSuperAdmin/EcranSuperAdmin";
import EcranEventsTracks from '../Ecrans/EcranEventsTracks/EcranEventsTracks';
import EcranPostmark from '../Ecrans/EcranPostmark/EcranPostmark';


import Popup from '../Components/Popup/Popup';
import PopupRadin from '../Components/Popup/PopupRadin';
import PopupWait from '../Components/Popup/PopupWait';
import PopupRadinConfirm from '../Components/Popup/PopupRadinConfirm';
import PopupAvertissementSignature from '../Components/Popup/PopupAvertissementSignature';
import PopupAvertissementResil from '../Components/Popup/PopupAvertissementResil';
import PopupALertPbContrat from '../Components/Popup/PopupAlertPbContrat';

import AfterCall from '../Ecrans/EcranFicheClient/AfterCall';
import CardChangeEmail  from '../Components/CardChangeEmail';
import ChangeMdp from '../Components/ChangeMdp';
import ComGestion from '../Components/ComGestion/ComGestion';
import ContratWin from '../Components/ContratWin/ContratWin';
import Calendar from '../Components/Calendar/Calendar';
import CardNewContratGestion from '../Components/Contrats/CardNewContratGestion';
import Echecs from '../Ecrans/EcranFicheClient/Echecs';
import ListEvents from '../Components/Calendar/ListEvents';
import Notifs from '../Components/Notifs/Notifs';
import ModifContrat from '../Components/Contrats/ModifContrat';
import Recherche from '../Components/Recherche';
import Sidebar from "../Components/Sidebar";
import TelephonieDraggable from '../Components/Telephone/TelephonieDraggable';
import FormEquipement from '../Components/Equipement/FormEquipement';
import RechercheContrats from '../Components/Gestion/RechercheContrats';
import MailingModal from '../Components/Email/MailingModal';
// import CardChangeStatutContrat from '../Components/CardChangeStatutContrat';

import { aircallphone } from '../utils/aircall';


import './Application.scss';
const Ecrans={'dashboard':<EcranDashboard />,
                'ficheclient':<EcranFicheClient />,
                // 'ecrantickets':<EcranTickets />,
                'params':<EcranParametres />,
                'dev': <EcranDev />,
                'dev2': <EcranDev2 />,
                'ecranemails':<EcranEmailsClients />,
                'ecranemailsgestion':<EcranEmailsGestion  />,
                'ecrangestion':<EcranGestion />,
                'ficheclientgestion':<EcranGestionOneClient /> ,
                'ecransuperadmin':<EcranSuperAdmin /> ,
                 'ecransuperadmintracks':<EcranEventsTracks /> ,
                 'ecranpostmark':<EcranPostmark />
        }

const demain =  new Date((new Date()).setHours(24,0,0)) ;

function Application(){ 

    const dispatch = useDispatch();
    const navigate = useNavigate();

  const {data: user} = useUser(localStorage.getItem('token'))  ;



    useEffect(()=>{  if(  user?.['type_tel']!=='aircall'){return }
                      aircallphone?.getTelephone()?.on('incoming_call',(callInfos)=>{handle_incoming_call(callInfos)}) ;
                      aircallphone?.getTelephone()?.on('call_end_ringtone',(callInfos)=>{handle_call_end_ringtone(callInfos)}) ;
                      aircallphone?.getTelephone()?.on('call_ended',(callInfos)=>{handle_call_ended(callInfos)}) ;
                      aircallphone?.getTelephone()?.on('comment_saved',(callInfos)=>{handle_comment_saved(callInfos)}) ;
                      aircallphone?.getTelephone()?.on('outgoing_call',(callInfos)=>{handle_outgoing_call(callInfos)}) ;
                      aircallphone?.getTelephone()?.on('outgoing_answered',(callInfos)=>{handle_outgoing_answered(callInfos)}) ;
                  });


    axios.defaults.baseURL = process.env.REACT_APP_URLBACK;

    axios.defaults.headers.post['Authorization'] = `Bearer ${localStorage.getItem('token')}` ;
    axios.defaults.headers.get['Authorization'] = `Bearer ${localStorage.getItem('token')}` ; 

    
    axios.interceptors.response.use(res => { return res;},    
                                    err => {  if(err?.response?.status===403){  
                                               axios_memory_memoclick({'url':err.config.url , 'data': err.config.data });
                                                localStorage.clear() ;
                                                // console.log('VERSLOGIN2') ;
                                                navigate('/login')  ;
                                               }
                                   return {status:err?.response?.status}});

    // const gleap = useSelector(state=>state.firstrequest.gleap)  ;
    const notifnew = useSelector(state=>state.display.notifnew)  ;
    const { messagetel} = useSelector(state=>state.tel);
    const listcalendarevents= useSelector(state => state.calendar.listcalendarevents);
    const [displaynotifs , setDisplaynotifs] = useState(false) ;
    const [alertrdv , setAlertrdv ] = useState(null)
    const {ecran ,  displaymodal , displaymodalcalendar}= useSelector(state=>state.display);

    

    const rdvsjour = listcalendarevents?.filter(x=>  (new Date(x.startDatetime) >new Date()) && (new Date(x.startDatetime) < demain ) );


    const findtimenextrdv = useCallback(() => {
        if(rdvsjour?.length===0){return }
        const firstrendezvous = rdvsjour.sort((a,b)=> new Date(a.startDatetime) - new Date(b.startDatetime))?.[0] ;
        const tempsnextrrdv_ms =( new Date(firstrendezvous?.startDatetime)  - new Date())/ 1000;
        if(tempsnextrrdv_ms <0){return }
        const nbhours = Math.floor(tempsnextrrdv_ms /3600) ; 
        const nbminutes = Math.floor((tempsnextrrdv_ms%3600)/60)?.toString().padStart(2,'0') ;
        const temps = nbhours>0?nbhours+'h'+nbminutes+'min':nbminutes+'min'; 
        firstrendezvous.id && setAlertrdv(`Votre prochain RDV est dans ${temps} avec ${firstrendezvous.summary} `) ;
    }, [rdvsjour]);

    useEffect(() => {
        findtimenextrdv() ; 
        const interval = setInterval(() => {findtimenextrdv()}, 60*1000);
        return () => clearInterval(interval);
      }, [findtimenextrdv]);


    // useEffect(()=>{
    //     window.history.pushState(null, document.title, window.location.href);
    //     window.addEventListener('popstate', function (event){
    //         window.history.pushState(null, document.title,  window.location.href);
    //     });
    //   // if(window.location.hostname==='localhost'){ window.onbeforeunload = function (e) {e.preventDefault()  ;return false;} }
    // }) ;




    window.addEventListener('click', (event) => { 
        (displaynotifs && (event.target.id!=='notifsbell' && !([...event.target.classList].includes('delnotif')) ))&& setDisplaynotifs(false) ;
     });

    useEffect(()=>{   if(user?.role==="GESTION"  ){dispatch(modifyEcran('ecrangestion')) ;  }
                      else if(user?.role==="SUPERADMIN"  ){dispatch(modifyEcran('ecransuperadmin')) ;  }
                    },[user,dispatch] );


  useEffect(()=>{  if(!localStorage.getItem('token')){    navigate('/login') ;  }
                   else if(!user?.["courtier"]){  return  ;}
                   else{verifieversion() ;initialiseSocket();findCourtierCompagniesDatas() ;
                        user?.['type_tel'] === 'twilio' && initialisetwilio() ;
                        user?.['type_tel']=== 'ringover' && initialiseringover() ;
                        user?.['type_tel']==='aircall' &&  initialiseaircall();
                        
                    }
                        // return () => {socketio && socketio?.off('connect');
                        //                socketio && socketio?.off('disconnect');
                        //                socketio && socketio?.off('allo');
                        //                socketio && socketio?.off('changestatutcontrat');
                        //                socketio && socketio?.off('changecommercialrecieve');
                        //                socketio && socketio?.off('supprimeleadcommercialrecieve');
                        //                socketio && socketio?.off('signature');
                        //                socketio && socketio?.off('signaturemandat');
                        //                socketio && socketio?.off('enterticket');
                        //                socketio && socketio?.off('notif');
                        //                socketio && socketio?.off('signatureyousign');
                        //                socketio && socketio?.off('enterlead');
                        //                socketio && socketio?.off('changestatutcontrat');
                        //                socketio && socketio?.off('arriveelead');
                        //                socketio && socketio?.off('changecontratstatut');
                        //                socketio && socketio?.off('changestatutmail');
                        //                socketio && socketio?.off('affectationticket');
                        //                socketio && socketio?.off('yousignsignature');
                        //                socketio && socketio?.off('resilsignature');
                        //                socketio && socketio?.off('arriveeticket');
                        //                socketio && socketio?.off('maildelivery');
                        //                socketio && socketio?.off('yousignsend');
                        //                socketio && socketio?.off('connect_error');
                        //                socketio && socketio?.off('connect_failed');
                        //                socketio && socketio?.off('disconnect');
                           
                        // };
                  },[user,navigate] );
                      


    // GLEAP         

    // useEffect(()=>{
    //     // if(!user?.['email'] ){return }
    //     if(!user?.['email'] || !gleap ){return }
    //     dispatch(defineGleap(false)) ; 
    //     Gleap.initialize("1SWQbVOLkiuU39dxBILcn1XrflnzIzJn");
    //     Gleap.setLanguage("fr"); 
    //     Gleap.identify(user['email'], { name: user['firstname'],email: user['email'], phone: user['telephone'] , customData:{'lastname': user['lastname'], 'courtier' :user['courtier']   } }) ;
    //     Gleap.registerCustomAction((customAction) => {
    //             if (customAction.name === "VISITE_GUIDEE") {
    //               document.getElementById("startdemo").click() }
    //           });
    // },[user,gleap,dispatch])



    const divnotifpopup = (notif)=>{
        return( <div   id='notif_popup'  className='notif_popup' >
                    <div className='notif_date' >{formatdatenotif(notif?.date_notif ?? new Date())}   {notif?.id} </div>
                    <div className='notif_texte' dangerouslySetInnerHTML={{__html: notif?.notification}} />     
             </div>)
    }

    return(<div  translate="no" className="administration">
         {alertrdv&& <div className='alertrdv'> <div>{alertrdv}</div></div>}
                      {user?.authenticate?<> <Popup   id="popupsignature"  />
                                             <Popup   id="popupsendmail"  />
                                              <Popup   id="popupdevis"  />
                                               <PopupAvertissementSignature /> 
                                               <PopupAvertissementResil  />
                                               <PopupALertPbContrat />
                                                {messagetel && <TelephonieDraggable />}
                                              
                                                {displaymodal==='mod_mailingmodal' && <MailingModal />}
                                                {displaymodal==='mod_popupradin' && <PopupRadin />}
                                                {displaymodal==='mod_popupwait' && <PopupWait />}
                                                {displaymodal==='mod_popuradinconfirm' && <PopupRadinConfirm />}
                                                {displaymodal==='mod_qualiflead' && <AfterCall />}
                                                {displaymodalcalendar==='mod_calendarrdv' && <Calendar  type='rdv' />}
                                                {displaymodalcalendar==='mod_calendarelance' && <Calendar  type='relance' />}
                                                {displaymodal==='mod_changemail' && <CardChangeEmail />}
                                                {/* {displaymodal==='mod_changestatucontrat' && <CardChangeStatutContrat />} */}
                                                {displaymodal==='mod_gestnewcontrat' && <CardNewContratGestion />}
                                                {displaymodal==='mod_changemdp' && <ChangeMdp />}
                                                {displaymodal==='mod_comgestion' &&  <ComGestion />}
                                                {displaymodal==='mod_contratwin' && <ContratWin />}
                                                {displaymodal==='mod_infos' && <EcranFormulaire />}
                                                {displaymodal==='mod_echecs' && <Echecs />}
                                                {displaymodal==='mod_searchgestion' && <GestionRecherche />}
                                                {displaymodal==='mod_searchcontrats' && <RechercheContrats />}
                                                {displaymodal==='mod_modifcontrat' && <ModifContrat />}
                                                {displaymodal==='mod_equipement' && <FormEquipement />}
                                                {displaymodal==='mod_search' && <Recherche />}
                                                <Sidebar  setDisplaynotifs={setDisplaynotifs}   displaynotifs={displaynotifs} />
                                                {ecran!=='dashboard' && <ListEvents position="moveleft" />}
                                                {Ecrans[ecran || 'dashboard']}
                                          </>:<></>}
                            {notifnew?.id && divnotifpopup(notifnew)}
                            {displaynotifs && <Notifs />}
                            {user?.type_tel === 'aircall' &&  <div id='aircallphone' ></div> }

             </div>)
}

export default Application


